import React from 'react';
import ReactDom from 'react-dom';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { SgiEventHandler } from './SgiEventHandler';
import { MediaResourceCode } from 'rt-sd-common/sgiFactory/MediaResourceCode'
import imgStyle from './SgiImg.css';
import { testReactVsn } from './sgiBaseComp/SgiCommon';


class SgiImg extends React.Component {
    static defaultProps = {
    };
    static props = {
    };

    constructor(props) {
        super(props);
        //初始化state
        this.state = {
            imgprops: {
                style: {}
            },
            functions: {},
        }
    }



    /**
    * @param {父组件} parentModule
    * @param {组件描述} moduleDesc
    * @param {绑定实例ID} bdInst
    * @param {对象工厂} objFct
    * @param {make类型} type
    */
    img_mk(parentModule, moduleDesc, bdInst, objFct, type) {
        if (!moduleDesc) {
            return;
        }
        this.AddImgAttribute(moduleDesc, this.state.imgprops);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.imgprops, this.state.functions, type);
    }
    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} treeProps
     */
    bindEvent(moduleDesc, imgprops, functions, type) {
        //拖拽模式 不生成事件
        if (type == 'dnd') {
            return;
        }
        var eck = moduleDesc.clkLsn; // 用户自定义点击事件
        if (eck) {
            var $eck = new Function("module", "objFct", eck);
            functions.onClick = $eck;
            imgprops.onClick = SgiEventHandler.onClick.bind(this);
        }

    }
    AddImgAttribute(moduleDesc, imgprops) {
        //显示图片
        var scId = moduleDesc.scId;
        if (scId) {
            var url = MediaResourceCode.getPrmUrl(scId);
            if (url) {
                imgprops.src = url;
            }
        } else {
            var disply = moduleDesc.disply;
            if (disply) {
                imgprops.src = disply;
            }
        }

        var show = moduleDesc.alt;
        if (show) {
            imgprops.alt = show;
        }
        //图片的大小设置
        var ctlH = moduleDesc.ctlH;
        if (ctlH) {
            imgprops.style.height = ctlH;
        }
        var ctlW = moduleDesc.ctlW;
        if (ctlW) {
            imgprops.style.width = ctlW;
        }

        var isHdn = moduleDesc.isHdn; //是否隐藏
        if (isHdn) {
            imgprops.style.display = "none"
        } else {
            imgprops.style.display = undefined;
        }
    }


    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }
    setUrl(url) {
        this.state.imgprops.src = url;
        this.setState(this.state.imgprops);
    }
    setHidden(hdn) {
        if (hdn) {
            this.state.imgprops.style.display = "none";
        } else {
            this.state.imgprops.style.display = undefined;
        }
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            this.state.imgprops.style = { ...this.state.imgprops.style };
        }
        this.setState(this.state.imgprops);
    }

    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            this.img_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }
        return (
            <div style={{ height: '100%', width: '100%' }}>
                <img className={imgStyle.pic} {...this.state.imgprops} />
            </div>
        );
    }
}
export { SgiImg };
export default SgiImg;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiImg.js